import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import { odata } from "../Filters/Helper";
import { ColumnHelper } from "util/TableHelper";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Tooltip,
  Popconfirm,
  Tabs,
  Form,
} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import { useMediaQuery } from "react-responsive";
import ErpPosReportTransactionV2Filter from "../Filters/ErpPosReportTransactionV2Filter";

function ErpPosReportTransactionV1Page() {
  const isBigScreen = useMediaQuery({
    query: "(min-device-width: 1824px)",
  });

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [order, setOrder] = useState("&$orderby=valueDate desc");
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    activeTab: "0",
    filter: "",
    queryString: ""
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [columnSettings, setColumnSettings] = useState();
  const [tabKeyValue, setTabKeyValue] = useState();
  const [projects, setProjects] = useState({
    data: [],
    loading: false,
  });

  const [firm, setFirm] = useState([]);

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/Firm?$select=id,name,firmBranchNumber,firmClassId,firmClassName&$filter=contains(tolower(firmClassName), 'banka') and ${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        if (res.value) {
          setFirm(res.value);
        }
      });
    } else {
      setFirm([]);
    }
  };

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setProjects({ data: res.value, loading: false });
        } else {
          setProjects({ data: [], loading: false });
        }
      });
    }
  };
  const getFilterQuery = () => {
    const { filter, activeTab } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    if (activeTab !== "-1") {
      conditions.push(`erpTransferStatusId Eq ${activeTab}`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "&$filter=" + conditions.join(" and ");
    }
    return query;
  };

  const isExportAvailable =
    tableDataQueryOptions.activeTab === "0" ||
    tableDataQueryOptions.activeTab === "3";

  useEffect(() => {
    if (columnSettings) {
      getTableData();
    }
  }, [order, tableDataQueryOptions, columnSettings]);

  useEffect(() => {
    getColumnSettings();
  }, []);

  const getColumnSettings = () => {
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setColumnSettings(response);
      } else {
        //erp tanımlı değilse sadece table loaderı kaldırdık
        setTableData({ ...tableData, loading: false });
      }
    });
  };

 

  const getTableData = () => {
    setSelectedRowKeys([]);
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;

    const queryStringKeys = Object.keys(tableDataQueryOptions.queryString);
    const queryString = queryStringKeys
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${
          encodeURIComponent(
          tableDataQueryOptions.queryString[key]
        )}`
    )
    .join("&");


    if(!queryStringKeys.includes("bankId") && !queryStringKeys.includes("valueDateStartDate") && !queryStringKeys.includes("valueDateEndDate")){
      notification.error({
        message:
        "Banka ve tarih aralığı filtresi seçilmelidir.",
        duration: 3,
      });
      setTableData({
        data: [],
        total: 0,
        loading: false,
      });
    }
    else if(moment(tableDataQueryOptions.queryString["valueDateEndDate"]).diff(tableDataQueryOptions.queryString["valueDateStartDate"],"days") > 31) {
      notification.error({
        message:
        "Tarih aralıkları arasında 30 günden fazla fark olamaz.",
        duration: 3,
      });
      setTableData({
        data: [],
        total: 0,
        loading: false,
      });
    }
    else {
      RequestHandler.get(
        `/ErpPosReportTransaction?${queryString}&$count=true${getFilterQuery()}${order}&$skip=${skip}&$top=${take}`
      ).then((response) => {
        if (Array.isArray(response.value)) {
          setTableData({
            data: response.value,
            total: response["@odata.count"],
            loading: false,
          });
        } else {
          setTableData({
            data: tableData.data,
            total: tableData.total,
            loading: false,
          });
        }
      });
    }

  };

  const getColumns = () => [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      align: "center",
      width: "8%",
      render: (text) => <img src={text}></img>,
    },
    {
      title: "Pos Tipi",
      dataIndex: "posType",
      align: "center",
    },
    {
      title: "İşlem Tarihi",
      dataIndex: "operationDate",
      key: "operationDate",
      sorter: true,
      align: "center",
      render: (data) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Valör Tarihi",
      dataIndex: "valueDate",
      key: "valueDate",
      sorter: true,
      align: "center",
      render: (data) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "İşlem Tutarı",
      dataIndex: "amount",
      key: "amount",
      render: ColumnHelper.renderDecimal,
    },
    {
      title: "Para Birimi",
      dataIndex: "currencyCode",
    },
    {
      title: "Taksit Sayısı",
      dataIndex: "installmentCount",
      align: "center",
    },
    {
      title: "Onay Kodu",
      dataIndex: "provisionNumber",
      align: "center",
    },
    {
      title: "Pos Terminal Hesap Kodu",
      dataIndex: "erpBankAccountCode",
      align: "center",
    },

    {
      title: "Cari",
      dataIndex: "firmId",
      width: "15%",
      render: (data, row, index) => (
        <Select
          allowClear
          showSearch
          placeholder="En az 2 harf giriniz.."
          defaultValue={data ?? undefined}
          disabled={!isExportAvailable}
          style={{ width: "100%" }}
          dropdownStyle={{ minWidth: "50%" }}
          onSearch={onFirmSearch}
          onChange={(value, option) => {
            let rows = [...tableData.data];
            let rowToUpdate = {
              ...row,
              firmId: value,
              firmName: option?.firmName,
              firmBranchNumber: option?.firmBranchNumber,
            };
            rows[index] = rowToUpdate;
            setTableData({ ...tableData, data: rows });
          }}
          filterOption={(input, option) =>
            option.children
              .toLocaleLowerCase("tr-TR")
              .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
          }
        >
          {data && (
            <Select.Option
              key={row.firmId}
              value={row.firmId}
              firmName={row.firmName}
              firmBranchNumber={row.firmBranchNumber}
              firmClassName={row.firmClassName}
            >
              {row.firmBranchNumber
                ? `${row.firmName} (${row.firmBranchNumber})`
                : row.firmName}
            </Select.Option>
          )}
          {firm
            .filter((item) => item.id != data)
            .map((item) => (
              <Select.Option
                key={item.id}
                value={item.id}
                firmName={item.name}
                firmBranchNumber={item.firmBranchNumber}
                firmClassName={item.firmClassName}
              >
                {item.firmBranchNumber
                  ? `${item.name} (${item.firmBranchNumber})`
                  : item.name}
              </Select.Option>
            ))}
        </Select>
      ),
    },

    {
      title: "Evrak No",
      dataIndex: "documentNumber",
      align: "center",
    },
    {
      title: "Durum",
      dataIndex: "erpTransferStatusId",
      align: "center",
      render: (i, row) => {
        const icon = {
          0: {
            component: <InfoCircleOutlined />,
          },
          1: {
            color: "green",
            component: <CheckCircleOutlined />,
          },
          2: {
            color: "orange",
            component: <ClockCircleOutlined />,
          },
          3: {
            color: "red",
            component: <CloseCircleOutlined />,
          },
        };
        let erpStatusText = row.erpTransferStatus;

        return (
          <Tooltip title={erpStatusText}>
            {icon[i] && (
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            )}
          </Tooltip>
        );
      },
    },
  ];
  const columns = getColumns();

  const paging = (p, filters, sorter) => {
    let order = "";
    if (sorter.columnKey && sorter.order) {
      order =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(order);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onConfirmSuccessfulExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (isSuccess) {
      selectedRowsData.map((item) => {
        if (item.firmId === null) {
          item.firmId = "00000000-0000-0000-0000-000000000000";
        }
      });
      RequestHandler.post(
        "/ErpPosReportTransaction/SetSuccessfulTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    }
  };

  const onConfirmNotTransferredExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpPosReportTransaction/SetNotTransferredTransfer",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onConfirmExport = () => {
    let isSuccess = true;

    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    // firmBranchNumber valuesu olmayan bir firm seçili ise
    if (selectedRowsData.some((row) => !row.firmBranchNumber)) {
      notification.error({
        message:
          "Seçili POS Hareketleri içerisinde Cari seçilmemiş kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

  

    if (isSuccess) {
      
      setTableData({
        ...tableData,
        loading: true,
      });

      RequestHandler.post("/ErpPosReportTransaction", selectedRowsData).then(
        (response) => {
          if (response.success) {
            getTableData();
          } else {
            isSuccess = false;
          }
        }
      );
    }
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      queryString: ""
    });
  };

  const onFinishTableFilter = (query,  queryString) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        queryString: queryString
      };
    });
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey
    });

    setTabKeyValue(tabKey);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={8} lg={16} xl={isBigScreen ? 16 : 15}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> POS RAPOR AKTARIM
          </p>
        </Col>
        <Col
          xs={tableDataQueryOptions.activeTab === "1" ? 24 : 24}
          md={tableDataQueryOptions.activeTab === "1" ? 24 : 8}
          lg={tableDataQueryOptions.activeTab === "1" ? 6 : 4}
          xl={tableDataQueryOptions.activeTab === "1" ? 8 : 6}
          style={{
            textAlign: "right",
            paddingLeft: "0px",
          }}
        >
          <Popconfirm
            title={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? "Aktarıldı olarak işaretlensin mi?"
                : "Aktarılmadı olarak işaretlensin mi?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? onConfirmSuccessfulExport
                : onConfirmNotTransferredExport
            }
            style={{ color: "seagreen" }}
          >
            {(tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "1" ||
              tableDataQueryOptions.activeTab === "3") && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined />{" "}
                {(tableDataQueryOptions.activeTab === "0" ||
                  tableDataQueryOptions.activeTab === "3") &&
                  "Aktarıldı Yap"}
                {tableDataQueryOptions.activeTab === "1" && "Aktarılmadı Yap"}
              </Button>
            )}
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{ textAlign: "right" }}
          hidden={tableDataQueryOptions.activeTab === "1"}
        >
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Erp'ye Aktar
              </Button>
            )}
          </Popconfirm>
        </Col>
      </Row>

      <ErpPosReportTransactionV2Filter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      ></ErpPosReportTransactionV2Filter>

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="-1" />
        <Tabs.TabPane tab="Aktarılmadı" key="0" />
        <Tabs.TabPane tab="Başarılı" key="1" />
        <Tabs.TabPane tab="Aktarılıyor" key="2" />
        <Tabs.TabPane tab="Başarısız" key="3" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            rowSelection={
              isExportAvailable
                ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                  }
                : tableDataQueryOptions.activeTab === "1"
                ? {
                    selectedRowKeys: selectedRowKeys,
                    onChange: onTableSelectChange,
                  }
                : undefined
            }
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
    </>
  );
}

export default ErpPosReportTransactionV1Page;
